import { render, staticRenderFns } from "./CategorySidebar.vue?vue&type=template&id=578dead8&scoped=true"
import script from "./CategorySidebar.vue?vue&type=script&lang=js"
export * from "./CategorySidebar.vue?vue&type=script&lang=js"
import style0 from "./CategorySidebar.vue?vue&type=style&index=0&id=578dead8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578dead8",
  null
  
)

export default component.exports